export const flexboxKeys = [
    'alignItems',
    'alignContent',
    'justifyItems',
    'justifyContent',
    'flexWrap',
    'flexDirection',
    'flex',
    'flexGrow',
    'flexShrink',
    'flexBasis',
    'gap',
    'columnGap',
    'rowGap',
    'justifySelf',
    'alignSelf',
    'order',
];
